import { Box, Button, Link } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../NewSettings.scss";

function OrganisationDetails() {
  const navigate = useNavigate();
  const [activePage, setActivePage] = React.useState("OrganisationDetails");
  const [section, setSection] = React.useState("");
  const [file, setFile] = React.useState("");

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };

  useEffect(() => {
    const windowURL = window.location.search;
    const params = new URLSearchParams(windowURL);

    let section = params.get("section");
    let page = params.get("page");

    setSection(section ?? "");
    setActivePage(page ?? "");
  }, []);
  function handleChange(e: any) {
    console.log(e.target.files);
    setFile(URL.createObjectURL(e.target.files[0]));
  }
  return (
    <Box className="settingMenuWrapper">
      <Grid container spacing={3}>
        <Grid xs={4} md={4} lg={4}>
          <div className="logosection ">
            <h6>Organasiation</h6>
            <img
              src={file.length > 0 ? file : "images/evervent_logo_one.svg"}
              alt=""
              className="companylogo"
            />
            <Link className="upload_img" component="label">
              <input
                hidden
                accept="image/*"
                multiple
                type="file"
                onChange={handleChange}
              />

              <img src="images/edit_image_icon.svg" alt="" />
            </Link>
            <h5>Evervent Pvt. ltd.</h5>
          </div>

          <div className="logosection">
            <h6>Organasiation</h6>
            <div className="Companydetail">
              <div className="text-left">
                <p>Industry</p>
                <h6>Software & Services</h6>
              </div>
              <div className="text-right">
                <p>Sub-Industry</p>
                <h6>Software</h6>
              </div>
            </div>
            <div className="Companydetail">
              <div className="text-left">
                <p>URL</p>
                <h6>www.evervent.in</h6>
              </div>
              <div className="text-right">
                <p>Tax ID</p>
                <h6>7895568564</h6>
              </div>
            </div>
            <div className="Companydetail">
              <div className="text-left">
                <p>Fiscal Year</p>
                <h5>2023</h5>
              </div>
              <div className="text-right">
                <p>Company ID</p>
                <h6>CN 8665854222</h6>
              </div>
            </div>
          </div>
        </Grid>
        <Grid xs={8} md={8} lg={8}>
          <div className="right_section">
            <Grid container spacing={3}>
              <Grid xs={12} className="text-left">
                <h5>
                  Primary Contact
                  <span>
                    You can use the following email addresses to sign in to your
                    account and also to reset your password if you ever forget
                    it.
                  </span>
                </h5>
              </Grid>
              <Grid xs={4} className="text-left">
                <p>Name</p>
                <h6>Kartike Kakkar</h6>
              </Grid>
              <Grid xs={4}>
                <p>Designation</p>
                <h6>Asso. Developer</h6>
              </Grid>
              <Grid xs={4}>
                <p>Email ID</p>
                <h6>kartike.kakkar77@gmail.com</h6>
              </Grid>
            </Grid>
          </div>
          <div className="right_section">
            <Grid container spacing={3}>
              <Grid xs={12} className="text-left">
                <h5>
                  Locale Information
                  <span>
                    You can use the following email addresses to sign in to your
                    account and also to reset your password if you ever forget
                    it.
                  </span>
                </h5>
              </Grid>
              <Grid xs={3} className="text-left">
                <p>Country/Region</p>
                <h6>India</h6>
              </Grid>
              <Grid xs={5}>
                <p>Time Zone</p>
                <h6>(GST 5:30) India Standard Time (Asia/Calcutta)</h6>
              </Grid>
              <Grid xs={4}>
                <p>Currency (Base Currency)</p>
                <h6>INR</h6>
              </Grid>
              <Grid xs={3}>
                <p>Language</p>
                <h6>English</h6>
              </Grid>
              <Grid xs={5}>
                <p>Date Format</p>
                <h6>dd/MM/yyyy (04/12/2022)</h6>
              </Grid>
              <Grid xs={4}>
                <p>Report Basis</p>
                <h6>Accrual (you owe tax as of invoice data)</h6>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid xs={12}>
          <div className="address_section">
            <Grid container spacing={3}>
              <Grid xs={12} className="text-left">
                <h5>
                  Address Details
                  <span>
                    You can use the following email addresses to sign in to your
                    account and also to reset your password if you ever forget
                    it.
                  </span>
                </h5>
              </Grid>
              <Grid xs={4} className="text-left">
                <p>Business Location</p>
                <h6>India</h6>
              </Grid>
              <Grid xs={4}>
                <p>Address</p>
                <h6>341, Industrial Area, Phase 9,Mohali</h6>
              </Grid>
              <Grid xs={4}>
                <p>Pincode</p>
                <h6>160062</h6>
              </Grid>
              <Grid xs={4}>
                <p>Phone Number</p>
                <h6>0162 5286932485</h6>
              </Grid>
              <Grid xs={4}>
                <p>Mobile Number</p>
                <h6>+91 98559 44512</h6>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
      {/* Footer Section */}
      <Grid container spacing={3} className="footerSection">
        <Grid xs={12} className="ctaBtn">
          <Button
            variant="contained"
            className="submitBtn"
            onClick={() => {
              navigate("/EditOrganisationDetails");
            }}
          >
            Edit
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}

export default OrganisationDetails;
